import * as a from '@mitranim/js/all.mjs'
import * as uti from './util-time.mjs'

/*
Note: in JSON, datetimes are encoded as strings. This validation function
potentially allows any representation convertible to a datetime. Might
reconsider.

TODO use `d.AbsTimespan` instead.
*/
export function isAbsTimespan(value) {
  return a.isStruct(value) &&
    uti.isConvertibleToValidTime(value.startAt) &&
    a.isIntPos(value.duration)
}

export function isAbsTimespanInDay(value, date, tzm) {
  a.req(value, isAbsTimespan)
  return uti.isSameDay(date, value.startAt, tzm)
}

export function absTimespanStartsBefore(val, nextStartAt) {
  return a.req(val, isAbsTimespan).startTimestamp < uti.toValidTimestamp(nextStartAt)
}

export function absTimespanStartsAtOrAfter(val, startAt) {
  return a.req(val, isAbsTimespan).startTimestamp >= uti.toValidTimestamp(startAt)
}

export function absTimespanEndsBefore(val, nextStartAt) {
  return a.req(val, isAbsTimespan).nextStartTimestamp <= uti.toValidTimestamp(nextStartAt)
}

export function absTimespanEqual(left, right) {
  return isAbsTimespan(left) &&
    isAbsTimespan(right) &&
    uti.dateEqual(left.startAt, right.startAt) &&
    left.duration === right.duration
}

export function getWeekday(value) {return a.laxStruct(value).weekday}

export function isAbsTimetable(value) {
  return a.isList(value) && a.every(value, isAbsTimespan)
}

export function onlyAbsTimetable(timetable) {
  timetable = a.arr(timetable)
  a.req(timetable, isAbsTimetable)
  return timetable
}

function absTimetableStartingAtOrAfter(src, startAt) {
  src = onlyAbsTimetable(src)
  return a.filter(src, val => absTimespanStartsAtOrAfter(val, startAt))
}

/*
Takes a sequence of absolute timespans and returns only the timespans that begin
before the given datetime. Some of them may end AFTER the given datetime.
*/
function absTimetableStartingBefore(timetable, nextStartAt) {
  timetable = onlyAbsTimetable(timetable)
  a.reqValidDate(nextStartAt)
  return a.filter(timetable, val => absTimespanStartsBefore(val, nextStartAt))
}

export function absTimetableBounded(table, startAt, nextStartAt) {
  table = onlyAbsTimetable(table)
  table = absTimetableStartingAtOrAfter(table, startAt)
  if (nextStartAt) table = absTimetableStartingBefore(table, nextStartAt)
  return table
}

export function findNearestTimespan(timetable, date) {
  a.reqValidDate(date)
  return a.find(timetable, val => absTimespanStartsAtOrAfter(val, date))
}
